import checkExistMembershipLevel from '../guards/check-exist-membership-level';
import { Routes } from '@angular/router';
import { EmemberComponent } from '../emember.component';
import setPageMembershipOffer from '../guards/set-page-membership-offer';
import setPageJoin from '../guards/set-page-join';
import defaultRouting from '../guards/default-routing.northway';
import { environment } from '../../../../environments/environment';
import setPageTitle from '../guards/set-page-title';
import ensurePriceLoadedGuard from '../guards/ensure-price-loaded.guard';
import { routes as quickRenewRoutes } from '../../quick-renew/quick-renew.routes';
import { routes as membershipOffersRoutes } from '../../membership-offers/membership-offers.routes';
import { routes as joinRoutes } from '../../join/join.routes';
import loadMembership from '../guards/load-membership.metadata';
import drupalUserSignedIn from '../guards/drupal-user-signed-in.northway';
import { routes as accountRoutes } from '../../account/account.routes';

export const routes: Routes = [
  {
    path: 'join',
    loadComponent: () => import('../../join/join').then((c) => c.Join),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, checkExistMembershipLevel, setPageJoin('join')],
    children: joinRoutes,
  },
  // {
  //   path: 'gift',
  //   loadComponent: () => import('../../join/join').then((c) => c.Join),
  //   canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageJoin('gift')],
  //   children: joinRoutes,
  // },
  {
    path: 'account',
    loadComponent: () => import('../../account/account').then((c) => c.Account),
    canActivate: [setPageTitle, drupalUserSignedIn, loadMembership],
    children: accountRoutes,
  },
  {
    path: 'renew',
    loadComponent: () => import('../../quick-renew/quick-renew').then((c) => c.QuickRenew),
    canActivate: [setPageTitle],
    children: quickRenewRoutes,
  },
  {
    path: 'offers',
    loadComponent: () => import('../../membership-offers/membership-offers').then((c) => c.MembershipOffers),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageMembershipOffer('offers')],
    children: membershipOffersRoutes,
  },
  // {
  //   path: 'gift-offers',
  //   loadComponent: () => import('../../membership-offers/membership-offers').then((c) => c.MembershipOffers),
  //   canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageMembershipOffer('gift-offers')],
  //   children: membershipOffersRoutes,
  // },
  {
    path: 'contact',
    loadComponent: () => import('../../contact/contact.component').then((c) => c.Contact),
    canActivate: [setPageTitle],
  },
  {
    path: '',
    component: EmemberComponent,
    ...(!environment.ngServe ? [defaultRouting] : []),
  },
];
